import {Component, ElementRef, Input, SimpleChanges, ViewChild} from '@angular/core';
import {FormControl, FormGroup, ValidationErrors} from '@angular/forms';
import * as moment from 'moment';

import {FontAwesomeService} from 'app/services/font-awesome.service';

@Component({
  selector: 'app-datepicker-field',
  template: `
    <ng-container [formGroup]="parent" >
      <fa-icon *ngIf="leadingIcon"
        (click)="datePicker.open()"
        class="leading-icon"
        [icon]="faService[leadingIcon]"
        matDatepickerToggleIcon
        style="cursor: pointer;"></fa-icon>
      <input
        (click)="datePicker.open()"
        #input
        type="text"
        (dateChange)="updateDate($event)"
        [matDatepicker]="datePicker"
        [formControlName]="controlName"
        [ngStyle]="inputStyles"
        animateInput
        [error]="error"
        [label]="labelRef"
        [leadingIcon]="true"
        [inputValue]="input.value"
        [isFocused]="datePicker.opened">
      <mat-datepicker #datePicker></mat-datepicker>
      <label #labelRef
        [ngClass]="leadingIcon ? 'leading-icon' : ''"
        [style.backgroundColor]="parent.get(controlName).disabled ? 'transparent' : 'white'"
        (click)="input.focus()">{{label}}</label>
      <validation-error
        [showError]="error"
        [errors]="errorSource.errors"
        [name]="label">
      </validation-error>
    </ng-container>
  `,
  styleUrls: ['../common.scss']
})
export class DatepickerFieldComponent {
  error = false;
  disabled = false;

  @Input() label: string;
  @Input() parent: FormGroup;
  @Input() controlName: string;
  @Input() submitted: boolean;
  @Input() leadingIcon: string;
  @Input() errorSource: FormGroup | FormControl;

  constructor(public faService: FontAwesomeService) {}

  updateDate(event) {
    this.parent.get(this.controlName)
      .setValue(event.target.value ? moment(event.target.value).format('YYYY-MM-DD') : null);
  }

  ngOnInit() {
    this.disabled = this.parent.get(this.controlName).disabled;
    if (this.disabled) {
      return;
    }

    this.errorSource.statusChanges
      .subscribe(status => this.error = status === 'INVALID');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.submitted && changes.submitted.currentValue && this.errorSource.invalid) {
      this.error = true;
    }
    if(changes.isReseting && changes.isReseting.currentValue) {
      this.error = false;
    }
  }

  get inputStyles() {
    return this.leadingIcon ? {paddingLeft: '34px'} : {};
  }
}



// WEBPACK FOOTER //
// ./src/app/components/form-fields/datepicker-field/app-datepicker-field.component.ts